import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en/translation.json';
import te from './locales/te/translation.json';
import hi from './locales/hi/translation.json';

i18n.use(initReactI18next).init({
    resources: {
        en: { translation: en },
        te: { translation: te },
        hi: { translation: hi },
    },
    lng: localStorage.getItem('vendora_lang') || 'en',
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
});

i18n.on('languageChanged', (lng) => {
    localStorage.setItem('vendora_lang', lng);
    // Persist to server if logged in (cross-device sync)
    const token = localStorage.getItem('access_token');
    if (token) {
        fetch('/api/auth/profile', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
            body: JSON.stringify({ preferred_language: lng }),
        }).catch(() => {}); // silent fail — not critical
    }
});

export default i18n;
